<template>
  <adivare-modal
    :active="active"
    id="signature-modal"
    :title="$t('messages_nl.partials.letter.modal.title')"
    className="modal-content"
    @close="closeModal"
  >
    <div class="block rounded bg-white outline outline-1 overflow-hidden relative outline-grey p-2 cursor-pointer mt-4 mb-2">
      <a
        @click="clearSignature"
        class="absolute inline-flex items-center group"
      >
        <img
          :src="$asset('img/cancellation/redo.svg')"
          :alt="$t('messages_nl.partials.letter.redo')"
          class="mr-1 transition-all group-hover:rotate-180"
          width="25"
          height="25"
          loading="lazy"
        >
        <p class="font-bold text-dark-blue">{{ $t('messages_nl.partials.letter.redo') }}</p>
      </a>
      <canvas
        id="signature"
        width="500"
        height="250"
      />
    </div>
    <adivare-alert
      v-if="!isDrawnSignatureRequired && !hasName"
      type="info"
      size="sm"
      show-icon
      class="cursor-pointer"
    >
      {{ $t('messages_nl.partials.letter.modal.noName') }}
    </adivare-alert>

    <div
      v-if="'undefined' !== typeof signatureObject && 0 < signatureObject.toData().length && !isDrawnSignatureRequired && hasName"
      class="flex justify-center mb-4"
    >
      <button
        @click="nameBasedSignature"
        type="button"
        class="font-bold text-dark-blue text-sm"
      >
        {{ $t('messages_nl.partials.letter.modal.name') }}
      </button>
    </div>
    <div class="flex justify-center">
      <button
        type="button"
        class="click-theme click-theme--primary click-theme--size-md m-2"
        @click="saveModal"
      >
        {{ $t('messages_nl.global.save') }}
      </button>
      <button
        type="button"
        class="click-theme click-theme--quinary click-theme--size-md m-2"
        @click="closeModal"
      >
        {{ $t('messages_nl.global.cancel') }}
      </button>
    </div>
  </adivare-modal>
</template>

<script>
import { fromCanvas, MODE_FROM_NAME, MODE_HAND_DRAWN } from "../../../signature-utils";
import AdivareModal from "../ui/modal";
import { mapGetters } from 'vuex';
import AdivareAlert from "../../../components/alert";

export default {
  name: 'adivare-signature-modal',
  components: {
    AdivareModal,
    AdivareAlert,
  },
  emits: [
    'closeModal'
  ],
  props: {
    target: {
      required: true,
      type: String
    },
    prefill: {
      type: Boolean,
      required: false,
      default: false,
    },
    active: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      isHandDrawn: false,
      isDrawnByInitialData: false,
      noNameAlertClass: 'hidden',
      signaturePadConfig: {
        penColor: 'rgb(033, 033, 033)',
      },
      signatureObject: undefined,
    }
  },
  computed: {
    ...mapGetters([
      'isDrawnSignatureRequired',
    ]),
    firstName() {
      return this.$store.getters.getFormField('customerFirstName');
    },
    lastName() {
      return this.$store.getters.getFormField('customerLastName');
    },
    hasName() {
      return null !== this.firstName || null !== this.lastName;
    },
    canvasElement() {
      return $('canvas#signature')[0];
    },
  },
  mounted() {
    this.createNewPad();
    this.isHandDrawn = this.$store.getters.signatureMode === MODE_HAND_DRAWN;
  },
  methods: {
    createNewPad() {
      this.signatureObject = fromCanvas(this.canvasElement);
      const signatureData = this.$store.getters.getSignatureData;
      if (signatureData !== undefined) {
        this.signatureObject.fromData(signatureData);
      }
    },
    closeModal() {
      this.$emit('closeModal')
    },
    saveModal() {
      this.saveSignature(this.signatureObject.canvasToDataURL());
      this.closeModal();
    },
    commitSignatureData(data) {
      this.$store.commit('signatureData', data);
    },
    saveSignature(value) {
      const data = this.signatureObject.toData();

      if (0 === data.length) return;

      this.commitSignatureData(data);

      this.$store.dispatch('updateFormField', {
        name: 'customerSignature',
        value
      });

      // Check if the saved signature contains any data.
      this.isHandDrawn = Array.isArray(data) && data.length > 0;

      this.$store.commit('updateFormFieldValidity', {
        name: 'customerSignature',
        valid: !this.isDrawnSignatureRequired || this.isHandDrawn,
      });
    },
    clearSignature() {
      this.signatureObject.clear();
      this.isHandDrawn = false;
    },
    nameBasedSignature() {
      this.clearSignature();
      this.nameToSignature();
      this.closeSignatureModal();
    },
    closeSignatureModal() {
      if (false === this.isHandDrawn && false === this.isDrawnSignatureRequired) {
        this.nameToSignature();
      }
      this.$store.commit('signatureMode', this.isHandDrawn ? MODE_HAND_DRAWN : MODE_FROM_NAME);
      this.closeModal();
    },
    openSignatureModal() {
      if (this.isHandDrawn === false) {
        this.clearSignature();
      }
    },
    nameToSignature() {
      if (true === this.hasName) {
        this.$store.dispatch('updateSignatureFromName');
        this.noNameAlertClass = 'hidden';
      } else {
        this.noNameAlertClass = 'block';
      }
    },
  },
}
</script>
